export const href = {
    openInNewWindowAttributes: (href: string) => ({
        href: `javascript:window.cordova.InAppBrowser.open('${encodeURI(href)}', '_system')`,
    }),
};
